/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategoryItem,
    BusinessCategoryItemFromJSON,
    BusinessCategoryItemFromJSONTyped,
    BusinessCategoryItemToJSON,
} from './BusinessCategoryItem';
import {
    ReferenceCompany,
    ReferenceCompanyFromJSON,
    ReferenceCompanyFromJSONTyped,
    ReferenceCompanyToJSON,
} from './ReferenceCompany';

/**
 * 
 * @export
 * @interface BusinessCategory
 */
export interface BusinessCategory {
    /**
     * busi_cate_idに相当
     * @type {string}
     * @memberof BusinessCategory
     */
    categoryId: string;
    /**
     * ビジネスカテゴリ名
     * @type {string}
     * @memberof BusinessCategory
     */
    name: string;
    /**
     * 内包されているビジネスカテゴリ一覧(busi_cate_lv2)
     * @type {Array<BusinessCategoryItem>}
     * @memberof BusinessCategory
     */
    categories: Array<BusinessCategoryItem>;
    /**
     * 参照企業の一覧
     * @type {Array<ReferenceCompany>}
     * @memberof BusinessCategory
     */
    referenceCompanies: Array<ReferenceCompany>;
}

export function BusinessCategoryFromJSON(json: any): BusinessCategory {
    return BusinessCategoryFromJSONTyped(json, false);
}

export function BusinessCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': json['category_id'],
        'name': json['name'],
        'categories': ((json['categories'] as Array<any>).map(BusinessCategoryItemFromJSON)),
        'referenceCompanies': ((json['reference_companies'] as Array<any>).map(ReferenceCompanyFromJSON)),
    };
}

export function BusinessCategoryToJSON(value?: BusinessCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_id': value.categoryId,
        'name': value.name,
        'categories': ((value.categories as Array<any>).map(BusinessCategoryItemToJSON)),
        'reference_companies': ((value.referenceCompanies as Array<any>).map(ReferenceCompanyToJSON)),
    };
}

